import { useState, useEffect, RefObject, useCallback } from 'react';
import { ContainerElement } from 'd3-selection';
import { DEFAULT_PADDING } from '../helpers/config';

export const useResize = (selector: RefObject<ContainerElement>, propsWidth?: number) => {
  const [width, setWidth] = useState(propsWidth || DEFAULT_PADDING.left + DEFAULT_PADDING.right);
  const resize = useCallback(() => {
    const container = selector.current;
    if (container) {
      setWidth(container.clientWidth >= 0 ? container.clientWidth : 0);
    }
  }, [selector.current]);
  useEffect(() => {
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, [resize]);

  return width;
};
